import React, { useState } from 'react';
import BuyNowCard from '../buy-now-card';
import styles from './style.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import CarouselArrows from 'components/swiper-carousel/components/arrows';
import ArrowIcon from 'components/icon/arrow-icon';
import useSizeClass from 'hooks/use-size-class';
import Link from 'components/link';

import type { PreConstructionProject } from '@zoocasa/pre-construction';
import type SwiperClass from 'swiper/types/swiper-class';

interface Props {
  listings: PreConstructionProject[];
  title: 'Buy Today' | 'Coming Soon';
  navigateToPath: '/newhomes/buy-today' | '/newhomes/coming-soon';
}

export default function ProjectListingSection({ listings, title, navigateToPath }: Props) {
  const [swiper, setSwiper] = useState<SwiperClass>();
  const isMobile = useSizeClass({ max: 768 });
  const isTablet = useSizeClass({ min: 769, max: 1099 });
  const slidesPerGroup = isMobile ? 1 : isTablet ? 2 : 3;

  const handleArrowPress = (directionOrIndex: 'next' | 'prev' | number) => {
    if (directionOrIndex === 'next') {
      swiper?.slideNext();
    } else if (directionOrIndex === 'prev') {
      swiper?.slidePrev();
    }
  };

  return (
    <div className={styles.component}>
      <section className={styles['title-row']}>
        <Link href={navigateToPath}>
          <h1>
            {title}
          </h1>
        </Link>
        <Link href={navigateToPath} className={`${styles.button} ${styles['mobile-button']}`} >
          More
        </Link>
        <Link href={navigateToPath} className={`${styles.button} ${styles['desktop-button']}`} >
          <>
            View More
            <ArrowIcon />
          </>
        </Link>
      </section>
      <Swiper
        onSwiper={setSwiper}
        slidesPerView={'auto'}
        spaceBetween={20}
        initialSlide={0}
        centerInsufficientSlides={true}
        slidesPerGroup={slidesPerGroup}
        freeMode={{
          enabled: true,
          minimumVelocity: 0.5,
        }}
        className={styles.swiper}
      >
        {listings.map((project, index) => (
          <SwiperSlide className={styles.card} key={index}>
            <BuyNowCard listing={project} />
          </SwiperSlide>
        ))}
      </Swiper>
      <CarouselArrows
        isLightbox={false}
        isListingCardCarousel={false}
        slideTo={handleArrowPress}
        className={styles.arrow}
      />
    </div>
  );
}
